export default "/images/vendor/flag-icons/flags/1x1/ag.svg?84f37e52a648579f7ee2797b5c71618d";